async function createSearchHighlightAnnotation(
  PSPDFKit,
  instance,
  selectionTxt,
  author,
  dictation,
  color,
  flagsList,
  numOfDownTag,
  numOfUpTag,
  pageStart,
  pageEnd,
  leftSentence,
  rightSentence,
  isUnderlined
) {
  let annotations = [];
  let results;
  let highlightFailed = false;

  if (!!selectionTxt) {
    try {
      if (pageStart === pageEnd) {
        results = await instance.search(selectionTxt, {
          startPageIndex: pageStart,
          endPageIndex: pageStart,
          caseSensitive: true
        });

        if (results.size === 0) {
          console.log(`No results for '${selectionTxt}' on page ${pageStart}`);

          results = await instance.search(selectionTxt.trim(), {
            startPageIndex: pageStart,
            endPageIndex: pageStart,
            caseSensitive: true
          });

          if (results.size === 0) {
            highlightFailed = true;
          }
        }

        if (results.size > 0) {
          const newAnnotations = await Promise.all(
            results.map(async (result) => {
              return await createHighlight(
                PSPDFKit,
                isUnderlined,
                result,
                flagsList,
                numOfDownTag,
                numOfUpTag,
                selectionTxt,
                color,
                dictation,
                author,
                null
              );
            })
          );
          annotations = annotations.concat(newAnnotations);
        }
      } else {
        let jsonArrayString;
        let jsonArray;
        let rects;

        // Search for leftSentence on pageStart
        results = await instance.search(leftSentence, {
          startPageIndex: pageStart,
          endPageIndex: pageStart,
          caseSensitive: true
        });
        jsonArrayString = JSON.stringify(results);
        jsonArray = JSON.parse(jsonArrayString);
        if (results.size > 1) {
          rects = new PSPDFKit.Geometry.Rect({
            left: jsonArray[jsonArray.length - 1].rectsOnPage[0].left,
            top: jsonArray[jsonArray.length - 1].rectsOnPage[0].top,
            width: jsonArray[jsonArray.length - 1].rectsOnPage[0].width,
            height: jsonArray[jsonArray.length - 1].rectsOnPage[0].height
          });
          const leftAnnotations = await createHighlight(
            PSPDFKit,
            isUnderlined,
            jsonArray[jsonArray.length - 1],
            flagsList,
            numOfDownTag,
            numOfUpTag,
            leftSentence,
            color,
            dictation,
            author,
            rects
          );
          annotations.push(leftAnnotations);
        } else {
          const leftAnnotations = await Promise.all(
            results.map(async (result) => {
              return await createHighlight(
                PSPDFKit,
                isUnderlined,
                result,
                flagsList,
                numOfDownTag,
                numOfUpTag,
                leftSentence,
                color,
                dictation,
                author,
                null
              );
            })
          );
          annotations = annotations.concat(leftAnnotations);
        }

        // Search for rightSentence on pageEnd
        results = await instance.search(rightSentence, {
          startPageIndex: pageEnd,
          endPageIndex: pageEnd,
          caseSensitive: true
        });
        jsonArrayString = JSON.stringify(results);
        jsonArray = JSON.parse(jsonArrayString);
        if (results.size > 1) {
          rects = new PSPDFKit.Geometry.Rect({
            left: jsonArray[0].rectsOnPage[0].left,
            top: jsonArray[0].rectsOnPage[0].top,
            width: jsonArray[0].rectsOnPage[0].width,
            height: jsonArray[0].rectsOnPage[0].height
          });
          const rightAnnotations = await createHighlight(
            PSPDFKit,
            isUnderlined,
            jsonArray[0],
            flagsList,
            numOfDownTag,
            numOfUpTag,
            rightSentence,
            color,
            dictation,
            author,
            rects
          );
          annotations.push(rightAnnotations);
        } else {
          const rightAnnotations = await Promise.all(
            results.map(async (result) => {
              return await createHighlight(
                PSPDFKit,
                isUnderlined,
                result,
                flagsList,
                numOfDownTag,
                numOfUpTag,
                rightSentence,
                color,
                dictation,
                author,
                null
              );
            })
          );
          annotations = annotations.concat(rightAnnotations);
        }
      }
    } catch (error) {
      console.error('Error during search and highlight creation:', error);
    }

    if (annotations.length > 0) {
      try {
        await instance.create(annotations);
      } catch (error) {
        console.error('Error creating annotations:', error);
      }
    }
  }
  return highlightFailed;
}

async function createHighlight(
  PSPDFKit,
  isUnderlined,
  result,
  flagsList,
  numOfDownTag,
  numOfUpTag,
  selectionTxt,
  color,
  dictation,
  author,
  rects
) {
  try {
    if (isUnderlined) {
      return new PSPDFKit.Annotations.UnderlineAnnotation({
        pageIndex: result.pageIndex,
        rects:
          rects !== null
            ? new PSPDFKit.Immutable.List([rects])
            : result.rectsOnPage,
        boundingBox:
          rects !== null
            ? rects
            : PSPDFKit.Geometry.Rect.union(result.rectsOnPage),
        subject: selectionTxt,
        customData: { flagsList, numOfDownTag, numOfUpTag },
        creatorName: author,
        color:
          color !== null
            ? PSPDFKit.Color.fromHex(color)
            : PSPDFKit.Color.transparent,
        flag: `Comment: ${dictation}`
      });
    } else {
      return new PSPDFKit.Annotations.HighlightAnnotation({
        pageIndex: result.pageIndex,
        rects:
          rects !== null
            ? new PSPDFKit.Immutable.List([rects])
            : result.rectsOnPage,
        creatorName: author,
        color:
          color !== null
            ? PSPDFKit.Color.fromHex(color)
            : PSPDFKit.Color.transparent,
        flag: `Comment: ${dictation}`,
        boundingBox:
          rects !== null
            ? rects
            : PSPDFKit.Geometry.Rect.union(result.rectsOnPage),
        subject: selectionTxt,
        customData: { flagsList, numOfDownTag, numOfUpTag }
      });
    }
  } catch (error) {
    console.error('Error creating highlight annotation:', error);
  }
}

const createAnnotation = async (
  PSPDFKit,
  instance,
  textSelectionBounded,
  author,
  dictation,
  myFlag
) => {
  //console.log(textSelectionBounded);
  await textSelectionBounded.getText().then(async (text) => {
    await textSelectionBounded
      .getSelectedRectsPerPage()
      .then((rectsPerPage) => {
        rectsPerPage.map(({ pageIndex, rects }) => {
          localStorage.setItem('pageIndex', pageIndex);
          // We need to create one annotation per page.
          //console.log('selectedTextStringify', JSON.stringify(rects));
          const annotation = new PSPDFKit.Annotations.HighlightAnnotation({
            creatorName: author,
            flag: `Comment: ${dictation}`,
            pageIndex,
            boundingBox: PSPDFKit.Geometry.Rect.union(rects),
            color: PSPDFKit.Color.fromHex('#90EE90'),
            rects,
            subject: text,
            customData: myFlag
          });
          instance.create(annotation);
        });
      });
  });
};

const createHighlightByPage = async (
  PSPDFKit,
  instance,
  pageIndex,
  filterByThumbs,
  listOfFlags
) => {
  let includeMine = false;
  let color = '';
  let array = [];
  let arrayNotIsMine = [];
  let arrayIsMine = [];
  let isUnderlined = false;
  let unhighlightedFlags = [];

  const editedListeOfFlags = listOfFlags?.filter(
    (item) => item?.sentence?.length > 0
  );

  if (filterByThumbs) {
    await Promise.all(
      editedListeOfFlags?.map(async (item) => {
        if (item.pageStart === pageIndex) {
          await Promise.all(
            item.notesInfos?.map(async (flag) => {
              if (!array.includes(item.sentence)) {
                array.push(item.sentence);
                color =
                  item.overlapping > 0 &&
                  item.numOfUpTag > 0 &&
                  item.numOfDownTag > 0
                    ? '#A68E4C'
                    : item.overlapping > 0 &&
                      item.numOfUpTag > 0 &&
                      item.numOfDownTag === 0
                    ? '#82F14B'
                    : item.overlapping > 0 &&
                      item.numOfUpTag === 0 &&
                      item.numOfDownTag > 0
                    ? '#D5544E'
                    : item.overlapping === 0 && item.numOfUpTag > 0
                    ? '#B6F88A'
                    : '#E9928D';

                const highlightFailed = await createSearchHighlightAnnotation(
                  PSPDFKit,
                  instance,
                  item.sentence?.replace(/\r?\n|\r/g, '').concat(' '),
                  flag.author,
                  flag.dictation,
                  color,
                  item.notesInfos,
                  item.numOfDownTag,
                  item.numOfUpTag,
                  parseInt(pageIndex, 10),
                  item.pageEnd,
                  item.leftSentence,
                  item.rightSentence,
                  isUnderlined
                );

                if (highlightFailed) {
                  unhighlightedFlags.push(
                    ...item.notesInfos.map((item) => item.flagId)
                  );
                }
              }
            })
          );
        }
      })
    );
  } else {
    await Promise.all(
      editedListeOfFlags?.map(async (item) => {
        includeMine = item.notesInfos?.filter((n) => n.isMine)?.length > 0;
        if (item.pageStart === pageIndex) {
          await Promise.all(
            item.notesInfos?.map(async (flag) => {
              if (flag.isMine) {
                if (!arrayIsMine.includes(item.sentence)) {
                  isUnderlined = item.notesInfos.length === 1 ? false : true;
                  arrayIsMine.push(item.sentence);

                  const highlightFailed = await createSearchHighlightAnnotation(
                    PSPDFKit,
                    instance,
                    item.sentence?.replace(/\r?\n|\r/g, '').concat(' '),
                    flag.author,
                    flag.dictation,
                    flag.color,
                    item.notesInfos,
                    item.numOfDownTag,
                    item.numOfUpTag,
                    parseInt(pageIndex, 10),
                    item.pageEnd,
                    item.leftSentence,
                    item.rightSentence,
                    isUnderlined
                  );

                  if (highlightFailed) {
                    unhighlightedFlags.push(
                      ...item.notesInfos.map((item) => item.flagId)
                    );
                  }
                }
              } else {
                if (!arrayNotIsMine.includes(item.sentence)) {
                  isUnderlined = false;
                  if (item.overlapping > 0) {
                    arrayNotIsMine.push(item.sentence);
                  }
                  color =
                    item.overlapping === 2 && includeMine
                      ? '#D6D6D6'
                      : item.overlapping > 1
                      ? '#A8A8A8'
                      : '#D6D6D6';

                  const highlightFailed = await createSearchHighlightAnnotation(
                    PSPDFKit,
                    instance,
                    item.sentence?.replace(/\r?\n|\r/g, '').concat(' '),
                    flag.author,
                    flag.dictation,
                    color,
                    item.notesInfos,
                    item.numOfDownTag,
                    item.numOfUpTag,
                    parseInt(pageIndex, 10),
                    item.pageEnd,
                    item.leftSentence,
                    item.rightSentence,
                    isUnderlined
                  );

                  if (highlightFailed) {
                    unhighlightedFlags.push(
                      ...item.notesInfos.map((item) => item.flagId)
                    );
                  }
                }
              }
            })
          );
        }
      })
    );
  }

  return unhighlightedFlags;
};

const highlightUnmatchedFlag = async (
  PSPDFKit,
  instance,
  unmatchedFlag,
  highlightColor
) => {
  const results = await instance.search(unmatchedFlag.text);

  if (results.size === 0) {
    return unmatchedFlag.flagId;
  } else {
    const annotations = results.map((result) => {
      return new PSPDFKit.Annotations.HighlightAnnotation({
        pageIndex: result.pageIndex,
        rects: result.rectsOnPage,
        boundingBox: PSPDFKit.Geometry.Rect.union(result.rectsOnPage),
        color: highlightColor
          ? PSPDFKit.Color.fromHex(highlightColor)
          : PSPDFKit.Color.fromHex('#f07ec2'),
        creatorName: unmatchedFlag.author,
        flag: `Comment: ${unmatchedFlag.dictation}`,
        subject: unmatchedFlag.sentence,
        customData: {
          flagsList: [unmatchedFlag],
          numOfDownTag: 0,
          numOfUpTag: 0
        }
      });
    });
    await instance.create(annotations);
    return null;
  }
};

export { createHighlightByPage, createAnnotation, highlightUnmatchedFlag };
